import { GeometryType } from "@evergis/api";
import { IconTypesKeys } from "@evergis/ui/dist/atoms/Icon/Icon";

export enum EditGeometryType {
  Raster = "raster",
  QLS = "qls",
}

type GeometryTypeOption = {
  text: string;
  value: GeometryType | EditGeometryType;
  icon?: IconTypesKeys;
  langKey?: string;
};

export const commonGeometryTypes: GeometryTypeOption[] = [
  {
    text: "Точки",
    value: GeometryType.Point,
    icon: "geom_point",
    langKey: "points",
  },
  {
    text: "Линии",
    value: GeometryType.Polyline,
    icon: "geom_polyline",
    langKey: "lines",
  },
  {
    text: "Полигоны",
    value: GeometryType.Polygon,
    icon: "geom_polygon",
    langKey: "polygons",
  },
];

export const geometryTypes: GeometryTypeOption[] = [
  ...commonGeometryTypes,
  {
    text: "Мультиточки",
    value: GeometryType.Multipoint,
    icon: "editgeom_point_addpart",
    langKey: "multipoint",
  },
  {
    text: "Растровый каталог",
    value: EditGeometryType.Raster,
    icon: "geom_raster",
    langKey: "raster",
  },
  {
    text: "Без геометрии",
    value: GeometryType.Unknown,
    icon: "table",
    langKey: "withoutGeometry",
  },
];

export const getGeometryType = (type: GeometryType): string =>
  type && type !== GeometryType.Unknown ? geometryTypes.find(geometry => geometry.value === type).langKey : "";
